import { sharedSchema } from "@shared-database/pgSchema";
import { leoID, timestampColumns } from "@shared-database/utils";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

/**
 * App-agnostic owner row for a materialized knowledge graph.
 *
 * Shared graph tables reference this row instead of any ChatAI profile model,
 * so the graph schema can remain reusable if another product surface owns a
 * graph in the future. ChatAI profiles point at this table from the ChatAI
 * schema, keeping that dependency one-way.
 */
export const KnowledgeGraph = sharedSchema.table("KnowledgeGraph", {
  // Mixins
  ...timestampColumns,

  // Properties
  id: leoID("id"),
});

// Types
export type KnowledgeGraphType = InferSelectModel<typeof KnowledgeGraph>;
export type KnowledgeGraphInsertType = InferInsertModel<typeof KnowledgeGraph>;
